export default {
    computed: {
        isCoursesFlow () {
            return ['online-courses', 'online-course', 'buy-online-course'].includes(this.$route.name);
        },

        isEventsFlow () {
            return ['events', 'events2', 'event'].includes(this.$route.name);
        },

        isMembershipsFlow () {
            return ['memberships', 'membership-plan', 'buy-membership-plan'].includes(this.$route.name);
        },
    }
}
